import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';

function Layout() {
  console.log('Layout rendering');
  const location = useLocation();
  const isTopicPage = location.pathname.startsWith('/topic/');

  return (
    <div className="bg-gray-50 min-h-screen">
      <div className="container mx-auto px-3 sm:px-4 py-4 sm:py-8">
        <header className="mb-4 sm:mb-8">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 sm:gap-0">
            <h1 className="text-2xl sm:text-3xl font-bold text-gray-900">
              <a href="/" className="hover:text-gray-700">poisdata.org</a>
            </h1>
            <nav className="flex items-center">
              <a href="/about" className="text-gray-600 hover:text-gray-900">About the Project</a>
            </nav>
          </div>
        </header>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-4 sm:gap-6">
          {!isTopicPage && (
            <div className="md:col-span-3">
              <Sidebar />
            </div>
          )}
          <div className={`${isTopicPage ? 'md:col-span-12' : 'md:col-span-9'}`}>
            <div className="bg-white p-3 sm:p-6 rounded-lg shadow">
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Layout;